import { render } from "./M2.vue?vue&type=template&id=771f20ae&scoped=true&ts=true"
import script from "./M2.vue?vue&type=script&lang=ts"
export * from "./M2.vue?vue&type=script&lang=ts"

import "./M2.vue?vue&type=style&index=0&id=771f20ae&lang=less&scoped=true"

import exportComponent from "/data/landun/workspace/vb-web-loan_V4.0D0116_B5_SVN51961bcd_635796/node_modules/.pnpm/vue-loader@16.8.3_vue@3.2.37+webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771f20ae"]])

export default __exports__